import styled from 'styled-components'

export const TextLine = styled.p`
  margin-bottom: 1.2em !important;
`